import {
  GET_ORGANIZATION_PROFILE,
  RESET_PROFILE_ACTION,
  START_LOADING_ORGANIZATION,
  ERROR_LOADING_ORGANIZATION,
  STOP_LOADING_ORGANIZATION,
} from "./action-types";
import { initialOrganizationData } from "./initialState";

const organizationReducer = (
  state = initialOrganizationData,
  action: any
): any => {
  switch (action.type) {
    case START_LOADING_ORGANIZATION:
      return {
        ...state,
        StateIs: "Pending",
      };
    case ERROR_LOADING_ORGANIZATION:
      return {
        ...state,
        StateIs: "Error",
      };
    case STOP_LOADING_ORGANIZATION:
      return {
        ...state,
        StateIs: "Idle",
      };
    case GET_ORGANIZATION_PROFILE:
      return action.payload;
    case RESET_PROFILE_ACTION:
      return initialOrganizationData;
    default:
      return state;
  }
};

export default organizationReducer;
